import Box from "@mui/material/Box";
import {Checkbox, Typography} from "@mui/material";
import ButtonCreate from "../../../components/UI/button/ButtonCreate";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import React, {useMemo, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import AddDetailBasedOnDetail from "../../../components/UI/modal/AddDetailBasedOnDetail";
import DetailCompositionController from "../../../API/organization/DetailCompositionController";
import RelateDelailController from "../../../API/organization/RelateDelailController";
import {typeRelateDetail} from "../../../data/ TypeRelateDetail";

const RelateDetailsTable = ({
                                handleModalAlert,
                                moduleId,
                                patternId,
                                data,
                                setData,
                                tableOptions,
                                tableOptionsHandle,
                                globalFilter,
                                handleSearchQuery,
                                filteredData,
                                columnsFilter,
                            }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const [showColumnFilters, setShowColumnFilters] = useState(false)

    const handleShowColumnFilters = () => {
        setShowColumnFilters(!showColumnFilters)
        if (showColumnFilters) {
            handleSearchQuery([], data, null, true)
        }
    }

    const columns = useMemo(() => {
        const baseColumns = [
            {
                id: 'detail',
                header: 'Деталь',
                accessorKey: 'detail.position',
                grow: true,
                Cell: ({cell, row}) => (
                    <Link
                        to={`/organization/requests-cutting/composition/${row.original.detail.id}`}>{row.original.detail.position}</Link>),
            },
            {
                id: 'name',
                header: 'Наименование',
                accessorKey: 'name',
                grow: true,
            },
            {
                id: 'typeComposition',
                header: 'Тип',
                accessorKey: 'typeComposition',
                size: 120,
                grow: false,
                Cell: ({cell}) => typeRelateDetail[cell.getValue()],
            },
        ]

        return baseColumns;

    }, [data, filteredData]);

    const handleAddDetail = (detail, values, close) => {
        setLoading(true)
        const api = patternId ? () => RelateDelailController.savePattern(moduleId, patternId, detail.id, values) : () => RelateDelailController.save(moduleId, detail.id, values)
        api().then(function (response) {
            setData(prev => [...prev, response.data])
            handleModalAlert("Деталь добавлена", 'success');
            close()
        })
            .catch(function (error) {
                handleModalAlert(error);
            }).finally(() => setLoading(false))
    }
    const handleDeleteRow = (row) => {
        const api = patternId ? () => RelateDelailController.deletePattern(row.id) : () => RelateDelailController.delete(row.id)
        api().then(function () {
            const newData = data.filter(el => el.id !== row.id)
            setData(newData)
            handleSearchQuery(globalFilter, newData)
            handleModalAlert("Данные удалены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }
    const menuItem = [
        {type: "delete", text: "Удалить", handler: handleDeleteRow},
    ]
    return (<Box
        sx={{
            overflow: 'auto',
            width: '100%',
        }}
    >
        <Box
            sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px"}}
        >
            <ButtonCreate
                text={"Добавить"}
                width={140}
                onClick={() => setModalOpen(true)}
            />
        </Box>
        <MaterialReactTable
            layoutMode="grid"
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}
            muiTablePaperProps={{
                sx: {
                    width: '100%',
                },
            }}
            muiTableContainerProps={{
                sx: {
                    width: '100%',
                    maxHeight: `calc(100vh - 420px)`
                }
            }}
            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "&:after": {
                        display: "none",
                    },
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "&:first-of-type": {
                        padding: 0,
                        width: "50px",
                        height: "36px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: (theme) => theme.palette.text.light,
                        "& .MuiButtonBase-root": {
                            borderRadius: "4px",
                            width: "24px",
                            height: "24px",
                            opacity: 1,
                            margin: 0,
                            padding: 0,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            }
                        }
                    },
                    "& a": {
                        color: "#006CCC",
                        textDecoration: "none",
                        "&:hover": {
                            textDecoration: "underline"
                        }
                    }

                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem"
                },
            }}
            muiTableBodyRowProps={({row}) => {
                return ({
                    sx: () => ({
                        height: '36px',
                        backgroundColor: "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        "&.MuiTableRow-root.Mui-selected": {
                            backgroundColor: (theme) => theme.palette.primary.light70,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.light50,
                            },
                        },
                        "&:hover": {
                            "& td:after": {
                                display: "none",
                            },
                            backgroundColor: (theme) => theme.palette.primary.stroke,
                        },
                        '&:nth-of-type(even)': {
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            backgroundColor: (theme) => theme.palette.primary.lightGrey,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: "",
                    size: 3,
                    minSize: 3,
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={filteredData}
            rowHeight={13}
            columnSpacing={1}
            getRowId={(originalRow) => originalRow.id}
            selectionPadding={1}
            onPaginationChange={(updater) => {
                tableOptionsHandle(updater(tableOptions));
            }}
            onGlobalFilterChange={(value) => {
                handleSearchQuery(value, data, null)
            }}
            onColumnFiltersChange={(updater) => {
                handleSearchQuery(updater(columnsFilter), data, null, true)
            }}
            onShowColumnFiltersChange={handleShowColumnFilters}
            state={{
                showColumnFilters: showColumnFilters,
                columnFilters: columnsFilter,
                globalFilter: globalFilter,
                showGlobalFilter: true,
                pagination: tableOptions,
            }}
            rowCount={tableOptions.totalElements}
            selectionCss={{
                backgroundColor: 'lightblue',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue',
                borderRadius: '4px',
            }}
            renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                return (el.type === "edit" || (el.type === "delete" && !row.original.blocked)) && <MenuItem
                    key={el.type}
                    onClick={() => {
                        el.handler(row.original)
                        closeMenu();
                    }}
                    sx={{
                        margin: "0 8px",
                        borderRadius: "4px",
                        "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                    }}
                >
                    {el.text}
                </MenuItem>
            })
            }
            localization={MRT_Localization_RU}
            enableRowActions={true}
            enableToolbarInternalActions={false}
        />
        {modalOpen && <AddDetailBasedOnDetail
            modalOpen={modalOpen}
            handleClose={() => setModalOpen(false)}
            handleSubmit={handleAddDetail}
            handleModalAlert={handleModalAlert}
            loading={loading}
            api={patternId ? () => DetailCompositionController.byModuleId(moduleId) : () => DetailCompositionController.forRelateDetailModule(moduleId)}
            relate={true}
        />}
    </Box>)
}
export default RelateDetailsTable